import { Component } from '@angular/core';
import { AngularModule } from '../../../../modules/angular.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { BreadcrumbsComponent } from '../../../ui/admin/breadcrumbs/breadcrumbs.component';
import { PurchasesTable } from '../../../ui/admin/purchases-table/purchases-table';
import { PurchaseForm } from '../../../forms/standard/purchase-form/purchase-form';
import { LicenseService } from '../../../../services/license';
import { PurchaseService } from '../../../../services/purchase';
import { AdminService } from '../../../../services/admin.service';
import { ClientSelectorComponent } from '../../../ui/admin/client-selector/client-selector.component';
import { Client, ClientPurchase, CreateClientPurchasePayload, UpdateClientPurchasePayload } from '@mira-avant/mtlibs';
import { Subscription } from 'rxjs';
import { LicensesTable } from '../../../ui/admin/licenses-table/licenses-table';

@Component({
	selector: 'app-purchases',
	standalone: true,
	imports: [
		AngularModule,
		ZorroModule,
		NzCardModule,
		NzDividerModule,
		BreadcrumbsComponent,
		PurchasesTable,
		PurchaseForm,
		ClientSelectorComponent,
		LicensesTable,
	],
	templateUrl: './purchases.html',
	styleUrl: './purchases.scss',
})
export class Purchases {
	public showPurchaseForm: boolean = false;
	public selectedClient: Client | undefined;
	public selectedPurchase: ClientPurchase | undefined;
	private sub?: Subscription;

	constructor(
		public purchaseService: PurchaseService,
		public licenseService: LicenseService,
		public adminService: AdminService
	) {
		this.sub = this.purchaseService.selectedPurchase$.subscribe(purchase => {
			this.selectedPurchase = purchase;
			this.showPurchaseForm = purchase !== undefined;
		});
	}

	public togglePurchaseForm(): void {
		this.showPurchaseForm = !this.showPurchaseForm;
	}

	public onSelectClient(client: Client) {
		if (this.selectedClient?.uuid === client.uuid) {
			this.selectedClient = undefined;
		} else {
			this.selectedClient = client;
		}
	}

	public async onPurchaseSubmit(payload: CreateClientPurchasePayload | UpdateClientPurchasePayload): Promise<void> {
		if (!this.selectedClient || !this.selectedClient.uuid) {
			throw new Error('No client selected');
		}

		try {
			let purchase: ClientPurchase;

			if (this.selectedPurchase) {
				// Update existing purchase
				purchase = await this.purchaseService.updatePurchase$(
					this.selectedPurchase.uuid,
					payload as UpdateClientPurchasePayload
				);
			} else {
				// Create new purchase
				purchase = await this.purchaseService.createPurchase$({
					client_uuid: this.selectedClient.uuid,
					...payload,
				} as CreateClientPurchasePayload);
			}
		} catch (error) {
			console.error('Error submitting purchase:', error);
		}
	}

	ngOnDestroy(): void {
		this.sub?.unsubscribe();
	}
}
